import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type SearchConfig {\n    livePaletteKeywords: [String]\n    keywordMinScore: [KeywordMinScore]\n    defaultMinScore: Int\n  }\n  type KeywordMinScore {\n    keyword: String\n    score: Int\n  }\n  type Query {\n    searchConfig: SearchConfig\n  }\n"])));
export var resolvers = {
  Query: {
    searchConfig: function () {
      var _searchConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _args, _ref) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataSources = _ref.dataSources;
                _context.next = 3;
                return dataSources.searchConfig.getSearchConfig();

              case 3:
                res = _context.sent;
                return _context.abrupt("return", {
                  livePaletteKeywords: res.live_palette_keywords,
                  keywordMinScore: res.keyword_min_score,
                  defaultMinScore: res.default_min_score
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function searchConfig(_x, _x2, _x3) {
        return _searchConfig.apply(this, arguments);
      }

      return searchConfig;
    }()
  }
};